import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const IconContainer = styled(Box)(({ theme }) => ({
	width: 24,
	height: 24,
	position: "relative",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	pointerEvents: "none",
}));

const Bar = styled("span")(({ theme, isOpen, position }) => {
	const baseStyles = {
		display: "block",
		position: "absolute",
		height: 2,
		width: "100%",
		backgroundColor: "currentColor",
		borderRadius: 2,
		opacity: 1,
		left: 0,
		transform: "rotate(0deg)",
		transition: "all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
		pointerEvents: "none",
	};

	// Position-specific styles
	const positionStyles = {
		top: {
			top: isOpen ? "50%" : 4,
			transform: isOpen ? "translateY(-50%) rotate(45deg)" : "none",
		},
		middle: {
			top: "50%",
			transform: "translateY(-50%)",
			opacity: isOpen ? 0 : 1,
			width: isOpen ? 0 : "100%",
		},
		bottom: {
			bottom: isOpen ? "auto" : 4,
			top: isOpen ? "50%" : "auto",
			transform: isOpen ? "translateY(-50%) rotate(-45deg)" : "none",
		},
	};

	return {
		...baseStyles,
		...positionStyles[position],
	};
});

/**
 * AnimatedMenuIcon - A hamburger menu icon that animates to an X when open
 * @param {boolean} isOpen - Whether the menu is currently open
 * @param {object} sx - Additional MUI sx styles
 */
const AnimatedMenuIcon = ({ isOpen = false, sx = {} }) => {
	return (
		<IconContainer sx={sx}>
			<Bar isOpen={isOpen} position="top" />
			<Bar isOpen={isOpen} position="middle" />
			<Bar isOpen={isOpen} position="bottom" />
		</IconContainer>
	);
};

export default AnimatedMenuIcon;
